// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 21:06:23

export default {
  "id": "furry-kung-fu-and-babushka",
  "slug": "furry-kung-fu-and-babushka",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/fe9cdca106a44a97a08d6eeed2af983a-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/fe9cdca106a44a97a08d6eeed2af983a/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Furry Kung Fu",
      "description": "Furry Kung-Fu & Babushka is a humorous fighting game with fun cartoon graphics, where controlling Cat or Babushka you need to inflict the enemy a series of hand-to-hand strikes, managing to dodge the sinister ball and sausage, which every second flies at you. Engage in epic hand-to-hand combat with park troublemakers. Earn achievements, get coins, unlock player skins! Will you be able to throw enemy sausage back at them? How long can you hold out? It's time to find out!",
      "instructions": "Controls on PC: arrow keys. \nControl on mobile: swipe and tap on the screen.\nPunch left: left arrow / tap on the screen to the left of the player. Punch right: right arrow / tap on the screen to the right of the player. \nCombo: multiple taps to the side you want to combo / multiple taps to the left or right of the player.",
      "genres": [
        "Battle"
      ],
      "tags": [
        "cartoon",
        "enemies",
        "fighting"
      ]
    },
    "zh-CN": {
      "title": "毛茸茸功夫",
      "description": "《毛茸茸功夫与俄罗斯套娃》是一款幽默的格斗游戏，拥有有趣的卡通图形，控制猫咪或俄罗斯套娃，你需要对敌人进行一系列的徒手打击，同时躲避每秒向你飞来的邪恶球和香肠。与公园里的捣蛋鬼进行史诗般的徒手格斗。赚取成就，获得金币，解锁玩家皮肤！你能否将敌人的香肠扔回去？你能坚持多久？是时候揭晓答案了！",
      "instructions": "PC上控制：方向键。\n移动端控制：滑动屏幕和点击屏幕。\n左勾拳：左箭头 / 点击玩家屏幕左侧。右勾拳：右箭头 / 点击玩家屏幕右侧。\n连击：连续点击你想要连击的一侧 / 连续点击玩家左侧或右侧。",
      "genres": [
        "战斗"
      ],
      "tags": [
        "卡通",
        "敌人",
        "战斗"
      ]
    },
    "zh-TW": {
      "title": "毛茸茸功夫",
      "description": "毛茸茸功夫與巴布什卡是一款幽默的格鬥遊戲，具有有趣的卡通圖形，操控貓或巴布什卡，你需要對敵人進行一系列的拳拳到肉攻擊，並成功躲避每秒飛向你們的陰險球和香腸。與公園的麻煩製造者進行經典的拳拳到肉格鬥。獲得成就、獲得硬幣、解鎖玩家皮膚！你能否將敵人的香腸丟回給他們？你能堅持多久？是時候揭曉答案了！",
      "instructions": "PC上的控制：方向鍵。\n手機上的控制：滑動和點擊螢幕。\n左勾拳：左方向鍵 / 在玩家左側點擊螢幕。右勾拳：右方向鍵 / 在玩家右側點擊螢幕。\n連擊：在您想要連擊的方向上多次點擊螢幕 / 在玩家左右兩側多次點擊。",
      "genres": [
        "戰鬥"
      ],
      "tags": [
        "卡通",
        "敵人",
        "戰鬥"
      ]
    },
    "zh-HK": {
      "title": "毛茸茸功夫",
      "description": "Furry Kung-Fu & Babushka是一部幽默格鬥遊戲，具有趣味的卡通圖形，操控貓或巴巴什卡，你需要對敵人進行一系列拳腳交加的攻擊，並且要成功躲避每秒飛向你的邪惡球和香腸。與公園的麻煩製造者進行經典的拳腳格鬥。贏取成就，獲得硬幣，解鎖玩家皮膚！你能夠將敵人的香腸拋回給他們嗎？你能堅持多久？是時候揭曉答案了！",
      "instructions": "PC控制：方向鍵。\n手機控制：滑動及觸碰螢幕。\n左擊拳：左方向鍵 / 觸碰玩家左方的螢幕。右擊拳：右方向鍵 / 觸碰玩家右方的螢幕。\n組合擊：連續觸碰想要組合的方向 / 觸碰玩家左方或右方的多下。",
      "genres": [
        "戰鬥"
      ],
      "tags": [
        "卡通",
        "敵人",
        "戰鬥"
      ]
    },
    "ja": {
      "title": "フリーカンフー",
      "description": "ファurry Kung-Fu & Babushkaは、楽しいカートゥーングラフィックで描かれたユーモラスな格闘ゲームで、猫やバブーシャを操り、敵に連続の手技を加え、一秒ごとに飛び込んでくる悪意あるボールやソーセージを避けながら、公園の問題児との壮大な手技格闘に挑戦します。アチーブメントを獲得し、コインをゲットし、プレイヤースキンを解凍！敵のソーセージを返し投げることができるか？どれくらい耐えられるか？それが今、判明する時です！",
      "instructions": "PCでのコントロール：アローキー。\nモバイルでのコントロール：スクリーンをスワイプしてタップ。\n左拳：左アローキー / プレイヤーの左側にスクリーンをタップ。\n右拳：右アローキー / プレイヤーの右側にスクリーンをタップ。\n連続技： comboしたい方向に複数回タップ / プレイヤーの左右に複数回タップ。",
      "genres": [
        "バトル"
      ],
      "tags": [
        "漫画風",
        "敵",
        "戦闘"
      ]
    },
    "ko": {
      "title": "퓨리 쿵fu",
      "description": "퍼리 쿵푸 & 바부시카는 재미있는卡通 그래픽으로 제공되는 유머러스한 전투 게임으로, 고양이나 바부시카를 조종하여 적에게 일련의 손을 맞추는 전투를 펼치고, 초마다向你飞来的邪恶球和香肠를 피해야 합니다. 공원의 괴롭힘을 하는 사람들과의 전설적인 손끝 전투에 참여하세요. 업적을 달성하고 동전을 얻어 플레이어 스킨을 해금하세요! 적의 햄을 그들에게 다시 던질 수 있을까요? 얼마나 오래 견딜 수 있을까요? 알아보는 시간이 되었습니다!",
      "instructions": "PC에서의 조작: 방향키.\n모바일에서의 조작: 스크롤과 화면 터치.\n왼쪽 패UNCH: 왼쪽 방향키 / 플레이어 화면 왼쪽에 터치.\n오른쪽 패UNCH: 오른쪽 방향키 / 플레이어 화면 오른쪽에 터치.\n콤보: 원하는 쪽으로 여러 번 터치 / 플레이어 왼쪽 또는 오른쪽에 여러 번 터치.",
      "genres": [
        "전투"
      ],
      "tags": [
        "카툰",
        "적",
        "싸움"
      ]
    },
    "fr": {
      "title": "Furri Kung Fu",
      "description": "Furry Kung-Fu & Babushka est un jeu de combats humoristique avec des graphismes cartoon amusants, où, en contrôlant le Chat ou la Babouchka, vous devez infliger à l'ennemi une série de coups de poing, tout en évitant la ballon et la saucisse sinistre qui volent vers vous à chaque seconde. Engagez-vous dans des combats de poings épiques avec des malfrats de parc. Gagnez des trophées, obtenez des pièces, débloquez des skins de joueur ! Serez-vous capable de renvoyer la saucisse ennemie vers eux ? Combien de tempserez-vous ? Il est temps de le découvrir !",
      "instructions": "Contrôles sur PC : touches fléchées.\nContrôles sur mobile : glisser et appuyer sur l'écran.\nCoup de poing gauche : flèche de gauche / appuyer sur l'écran à gauche du personnage.\nCoup de poing droit : flèche de droite / appuyer sur l'écran à droite du personnage.\nCombinaison : plusieurs appuis sur le côté souhaité pour la combinaison / plusieurs appuis à gauche ou à droite du personnage.",
      "genres": [
        "Bataille"
      ],
      "tags": [
        "cartoon",
        "ennemis",
        "combat"
      ]
    }
  }
};
